import { useMediaQuery } from '@material-ui/core';

import { lenderFieldColumn } from '@/components/modules/Reports/ReportsList/components/ReportsDataGridFields/components/lenderFieldColumn';
import { reportDateFieldColumn } from '@/components/modules/Reports/ReportsList/components/ReportsDataGridFields/components/reportDateFieldColumn';
import { reportIdFieldColumn } from '@/components/modules/Reports/ReportsList/components/ReportsDataGridFields/components/reportIdFieldColumn';
import { toReportDetailFieldColumn } from '@/components/modules/Reports/ReportsList/components/ReportsDataGridFields/components/toReportDetailFieldColumn';
import { totalAdjustmentsAmountFieldColumn } from '@/components/modules/Reports/ReportsList/components/ReportsDataGridFields/components/totalAdjustmentsAmountFieldColumn';
import { totalAmountDisbursedFieldColumn } from '@/components/modules/Reports/ReportsList/components/ReportsDataGridFields/components/totalAmountDisbursedFieldColumn';
import { useUser } from '@/hooks/useUser';

import { useCustomTheme } from '../../../../../../hooks/useCustomTheme';
import { businessNameFieldColumn } from './components/businessNameFieldColumn';
import { reportDateAndReferenceMobileFieldColumn } from './components/reportDateAndReferenceMobileFieldColumn';

export function ReportsDataGridFields() {
  const { breakpoints } = useCustomTheme();
  const { userEntity } = useUser();

  const isMerchantIdFieldAllowed = !(userEntity?.agent && userEntity.channel && userEntity.merchant);

  const isDownMd = useMediaQuery(breakpoints.down('md'));

  const defaultReportsFields = {
    desktop: [
      reportIdFieldColumn({ flex: 0.15 }),
      isMerchantIdFieldAllowed ? businessNameFieldColumn({ flex: 0.35 }) : [],
      reportDateFieldColumn({ flex: 0.25 }),
      lenderFieldColumn({ flex: 0.25 }),
      totalAdjustmentsAmountFieldColumn({ flex: 0.25 }),
      totalAmountDisbursedFieldColumn({ flex: 0.25 }),
      toReportDetailFieldColumn({ flex: 0.15 }),
    ],
    mobile: [
      reportDateAndReferenceMobileFieldColumn({ flex: 0.4 }),
      lenderFieldColumn({ flex: 0.3 }),
      totalAmountDisbursedFieldColumn({ flex: 0.3 }),
    ],
  };

  const DataGridFields = {
    report: defaultReportsFields.desktop,
  };

  const MobileDataGridFields = {
    report: defaultReportsFields.mobile,
  };

  return isDownMd ? MobileDataGridFields.report : DataGridFields.report;
}

export type DataGridFields = ReturnType<typeof ReportsDataGridFields>;
